import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { UrlModal } from "src/app/shared/url.model";

@Injectable({
  providedIn: "root",
})
export class AppointmentService {
  //URL = "http://localhost:3005";
  URL = "http://206.189.132.38:3005";

  constructor(private httpClient: HttpClient) {}

  saveAppointment(docId, patnum, patId, token, appDate, status) {
    return this.httpClient.post(
      UrlModal._URL + "/ap/saveappointment",
      {
        doctorId: docId,
        patientId: patId,
        patientNumber: patnum,
        appointmentDate: appDate,
        status: status,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  getPatientAppointment(patientId, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);  
    params = params.append("limit", "10");
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + "/ap/getpatientappointment",
        {
          patientId: patientId,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs;

          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }
  getDoctorAppointment(id, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + "/ap/docappointment",
        {
          id: id,
        },

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split("T")[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            limit: resData.data.limit,
            page: resData.data.page,
            total: resData.data.limit,
          };
        })
      );
  }
  getDoctorAppointmentByDate(appDate, docId, token, page, clinicId) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "50");
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + "/ad/admindocAppByDate",
        {
          doctorId: docId,
          appointmentDate: appDate,
          clinicId: clinicId,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split("T")[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            limit: resData.data.limit,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }
  getPatientAppointmentByDate(appDate, patId, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + "/ad/adminpatAppByDate",
        {
          id: patId,
          appointmentDate: appDate,
          allAppt:true
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split("T")[0];
            return { ...sinapp, appointmentDate };
          });
          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
            All: resData.data.all
          };
        })
      );
    }

  getDoctorAppointmentByStatus(appDate, docId, token) {
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + "/ap/filterbystatus",
        {
          doctorId: docId,
          appointmentDate: appDate,
          status: "CANCEL",
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split("T")[0];
            return { ...sinapp, appointmentDate };
          });

          return appArray;
        })
      );
  }

  allData(
    token: any,
    days:number
  ) {
    return this.httpClient
      .get(
        UrlModal._URL + "/ad/notInstallpat?subDay="+days,
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  updatePatientStatus(
    docId: string,
    patientId: string,
    appointmentDate: number,
    token: any,
  ) {
    return this.httpClient
      .post(
        UrlModal._URL + "/ap/appointmentstatus",
        {
          doctorId: docId,
          patientId: patientId,
          appointmentDate: appointmentDate,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  count(token){
    return this.httpClient.get(UrlModal._URL+'/ad/count',{
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      })
    })
  }
}
export interface appointmentData {
  status: number;
  message: string;
  data: {
    _id: string;
    isDeleted: boolean;
    isEnabled: boolean;
    doctorId: string;
    patientId: string;
    appointmentDate: Date;
    patientNumber: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
export interface DocAppointmentData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        doctorId: {
          _id: string;
          name: string;
          doctorType: string;
          email: string;
          phoneNo: number;
          degree: string;
        };
        patientId: {
          _id: string;
          isDeleted: boolean;
          isEnabled: boolean;
          name: string;
          email: string;
          phoneNo: number;
          createdAt: string;
          updatedAt: string;
          __v: number;
        };
        appointmentStatus: string;
        appointmentDate: string;
        appointmentNumber: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    All: number;
    total: number;
    limit: number;
    all:number;
    page: number;
    pages: number;
  };
}
export interface patAppointmentData {
  status: number;
  message: string;
  data: [
    {
      _id: string;
      isDeleted: boolean;
      isEnabled: boolean;
      doctorId: {
        _id: string;
        name: string;
        doctorType: string;
        email: string;
        degree: string;
      };
      patientId: {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        name: string;
        email: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      };
      appointmentStatus: string;
      appointmentDate: string;
      appointmentNumber: number;
      patientName: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
